import React, { forwardRef } from "react";

import { IBodyProps } from "./Body1";
import { ITypographyProps, Typography } from "../Typography";

export const Body2 = forwardRef<
  HTMLDivElement,
  IBodyProps & Omit<ITypographyProps, keyof IBodyProps | "variant">
>(({ weight = "regular", children, ...props }, ref) => {
  return (
    <Typography variant="Body 2" weight={weight} ref={ref} {...props}>
      {children}
    </Typography>
  );
});

Body2.displayName = "Body2";
